export default {
  meta: {
    title: '储备店管理',
    parentPath: ['/storemanage'],
    url: '/storemanage/reserve', // 埋点用，记录所属模块
    // eventId: 'db7e1a42-764d-4799-95b5-988bf4f3d403'
  },
};
